import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}
const handleAddToCart = () => {
  window.fbq?.('track', 'AddToCart', {
    content_name: 'Metabolismo 40+ Reset',
    content_ids: ['48074557849854'],
    content_type: 'product',
    value: 6.39,
    currency: 'USD'
  });
  window.open('https://abundiacrece.com/cart/48074557849854:1', '_blank');
};
export function OfferSection() {
  return <section id="offer" className="py-24 px-6 md:px-12 bg-white" data-id="element-112">
      <div className="max-w-4xl mx-auto text-center" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-cream p-8 md:p-12 rounded-[2.5rem] shadow-xl border-4 border-sage/20" data-id="element-114">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-6" data-id="element-115">
            Recupera el control de tu cuerpo hoy mismo.
          </h2>
          <p className="text-xl text-gray-700 mb-8 max-w-2xl mx-auto" data-id="element-116">
            No pagues cientos de dólares en consultas nutricionales que no
            entienden la menopausia o perimenopausia.
          </p>

          <div className="bg-white py-8 px-6 rounded-3xl shadow-inner mb-8 max-w-md mx-auto" data-id="element-117">
            <p className="text-gray-500 font-medium mb-2 uppercase tracking-wider text-sm" data-id="element-118">
              Precio Regular
            </p>
            <div className="flex justify-center items-start gap-1" data-id="element-119">
              <span className="text-2xl font-bold text-gray-400 mt-2 line-through" data-id="element-120">
                $
              </span>
              <span className="text-5xl font-bold text-gray-400 line-through" data-id="element-121">
                27
              </span>
              <span className="text-lg font-bold text-gray-400 mt-6 line-through" data-id="element-122">
                USD
              </span>
            </div>
            <p className="text-coral font-bold uppercase tracking-wider text-sm mt-4 mb-2" data-id="element-123">
              🔥 Precio de Descuento
            </p>
            <div className="flex justify-center items-start gap-1" data-id="element-124">
              <span className="text-3xl font-bold text-charcoal mt-2" data-id="element-125">$</span>
              <span className="text-7xl font-bold text-charcoal" data-id="element-126">6,39</span>
              <span className="text-xl font-bold text-gray-400 mt-8" data-id="element-127">USD</span>
            </div>
            <p className="text-sage font-bold mt-4" data-id="element-128">
              Acceso de por vida al sistema completo "Metabolismo 40+ Reset"
            </p>
          </div>

          <Button onClick={handleAddToCart} className="w-full md:w-auto md:px-12 py-5 text-xl shadow-coral/30" data-id="element-129">
            ¡QUIERO MI RESET METABÓLICO AHORA!
          </Button>
        </motion.div>
      </div>
    </section>;
}